import styled from '@emotion/styled'
import { Box, type BoxProps, CircularProgress } from '@mui/material'

interface BoxStyledProps extends BoxProps {
  isroute: number
}

interface CircularProgressProps {
  customcolor: string
}

export const BoxStyled = styled(Box)<BoxStyledProps>`
  display: flex;
  min-height: ${({ isroute }) => (isroute ? '100vh' : '100%')};
  min-width: ${({ isroute }) => (isroute ? '100vw' : '100%')};
`
export const CircularProgressStyled = styled(CircularProgress)<CircularProgressProps>`
  margin: auto;
  color: ${({ customcolor }) => customcolor};
`
